import GalleryWithCounterView from "../GalleryWithCounterView/GalleryWithCounterView";

type GalleryViewModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
  ReceivedMedia?: any;
  OtherMedia: any;
  itemIndex?: number;
  applyRadius?: boolean;
  productType?: string;
  resizeImage?: boolean;
  extraSmallImage?: boolean;
  ceterIconTheme?: string;
  containerWidth: number;
  testIDPrefix?: string;
};

const CollectionGalleryWithCounterView = ({
  OtherMedia,
  itemIndex,
  applyRadius,
  ReceivedMedia,
  productType,
  resizeImage = false,
  extraSmallImage = false,
  ceterIconTheme = "",
  containerWidth,
  testIDPrefix,
}: GalleryViewModalProps) => {
  return (
    <GalleryWithCounterView
      ReceivedMedia={OtherMedia?.[itemIndex as number]?.media}
      OtherMedia={ReceivedMedia}
      image_thumb_url={OtherMedia?.[itemIndex as number]?.image_thumb_url}
      applyRadius={applyRadius}
      productType={productType}
      itemDetail={OtherMedia?.[itemIndex as number]}
      resizeImage={resizeImage}
      extraSmallImage={extraSmallImage}
      ceterIconTheme={ceterIconTheme}
      containerWidth={containerWidth}
      testIDPrefix={testIDPrefix}
    />
  );
};

export default CollectionGalleryWithCounterView;
